<template>
  <vs-row v-if="this.calldata[0]">
    <!-- <pre>{{ edit_name }}</pre> -->
    <template v-for="(item, i) in Object.keys(read[0].control)">
      <vs-col
        vs-lg="3"
        vs-xs="6"
        v-if="read[0].control[item]['visible']"
        :key="i"
        style="padding: 1.5%"
      >
        <!-- <vs-card class="cardborder" v-if="windowWidth > 600">
          <vs-row>
            <div class="edit_hover_class d-flex">
              <h4 class="card-title" style="color: #333f50">
                {{ item }}
              </h4>
              <a
                @click="(popupActivo = true), (valuename = item)"
                class="iconcursoredit"
                ><vs-icon class="ml-1 mt-1" icon="edit" size="15px"></vs-icon
              ></a>
            </div>
            <vs-spacer />
            <vs-icon
              icon="fiber_manual_record"
              v-if="read[0].control[item]['value'] == true"
              color="success"
            ></vs-icon>
            <vs-icon
              icon="fiber_manual_record"
              v-if="read[0].control[item]['value'] == false"
              color="#FF0000"
            ></vs-icon
          ></vs-row>
          <p
            style="text-align: center; font-size: 350%"
            v-if="read[0].control[item]['value'] == true"
          >
            ON
          </p>
          <p
            style="text-align: center; font-size: 350%"
            v-if="read[0].control[item]['value'] == false"
          >
            OFF
          </p>
        </vs-card> -->
        <vs-card
          :key="rediv"
          v-if="read[0].control[item]['value'] == false"
          class="cardborder"
        >
          <vs-row style="display: flex; align-items: center">
            <h1>
              <vs-icon icon="lightbulb" size="50px" color="#32c040"></vs-icon>
            </h1>
            <vs-spacer />
            <h4 class="colorgray">OFF</h4>
          </vs-row>
          <br />

          <div class="edit_hover_class d-flex">
            <h4 style="color: #111111">
              <b>{{ name_data[i].name }}</b>
            </h4>
            <a
              @click="
                (popupActivo = true),
                  (valuename = name_data[i].name),
                  (edit_name = name_data[i])
              "
              class="iconcursoredit"
              ><vs-icon class="ml-1 mt-1" icon="edit" size="15px"></vs-icon
            ></a>
          </div>
        </vs-card>
        <vs-card
          :key="rediv"
          v-if="read[0].control[item]['value'] == true"
          style="background: #32c040"
          class="cardborder"
        >
          <vs-row style="display: flex; align-items: center">
            <h1>
              <vs-icon
                icon="wb_incandescent"
                style="transform: rotate(180deg)"
                size="50px"
                color="#ffffff"
              ></vs-icon>
            </h1>
            <vs-spacer />
            <h4 style="color: #ffffff">ON</h4>
          </vs-row>
          <br />
          <div class="edit_hover_class d-flex">
            <h4 style="color: #ffffff">
              <b>{{ name_data[i].name }}</b>
            </h4>
            <a
              @click="
                (popupActivo = true),
                  (valuename = name_data[i].name),
                  (edit_name = name_data[i])
              "
              class="iconcursoredit"
              ><vs-icon class="ml-1 mt-1" icon="edit" size="15px"></vs-icon
            ></a>
          </div>
        </vs-card>
        <!-- <vs-card v-else>
          <h6 class="card-title d-flex" style="color: #333f50">
            {{ item }}
          </h6>
          <p
            style="text-align: center; font-size: 150%"
            v-if="read[0].control[item]['value'] == true"
          >
            ON
          </p>
          <p
            style="text-align: center; font-size: 150%"
            v-if="read[0].control[item]['value'] == false"
          >
            OFF
          </p>
        </vs-card> -->
      </vs-col>
    </template>
    <vs-popup class="holamundo" title="Edit" :active.sync="popupActivo">
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="2"
          vs-sm="2"
          vs-xs="2"
        >
          Name
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
          <vs-input class="inputx" v-model="valuename" />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-spacer />
        <vs-button
          color="dark"
          class="widthbtn"
          @click="popupActivo = false"
          type="flat"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 widthbtn"
          @click="editname(valuename, edit_name)"
          type="filled"
          >Save</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-row :key="rediv" vs-w="12">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card class="cardborder">
          <vs-table stripe :data="Object.keys(read[0].control)">
            <template slot="header">
              <h4 class="mb-3 mt-2">Control Switch</h4>
            </template>
            <template slot="thead">
              <vs-th style="padding: 0px"> Name </vs-th>
              <vs-th style="padding: 0px"> Status </vs-th>
              <vs-th style="padding: 0px"> Switch </vs-th>
              <vs-th style="padding: 0px"> Timestamp </vs-th>
            </template>

            <template slot-scope="{ data }">
              <template v-for="(tr, indextr) in data">
                <vs-tr
                  :key="indextr"
                  v-if="read[0].control[data[indextr]]['visible']"
                >
                  <vs-td>
                    <!-- {{ data[indextr] }} -->
                    {{ name_data[indextr].name }}
                  </vs-td>
                  <vs-td v-if="read[0].control[data[indextr]]['value'] == 1">
                    <div class="d-flex">
                      <vs-icon
                        class="mr-1"
                        icon="fiber_manual_record"
                        color="#32c040"
                      ></vs-icon>
                      <h5 class="mt-1 colorgray">ON</h5>
                    </div>
                  </vs-td>
                  <vs-td v-if="read[0].control[data[indextr]]['value'] == 0">
                    <div class="d-flex">
                      <vs-icon
                        class="mr-1"
                        icon="radio_button_unchecked"
                        color="#32c040"
                      ></vs-icon>
                      <h5 class="mt-1 colorgray">OFF</h5>
                    </div>
                  </vs-td>
                  <vs-td>
                    <vs-button
                      color="#32c040"
                      class="widthbtn"
                      @click="btnChange(data[indextr], indextr)"
                      v-if="read[0].control[data[indextr]]['visible']"
                      type="filled"
                      icon="power_settings_new"
                      >Switch</vs-button
                    >
                  </vs-td>

                  <vs-td v-if="read[0].jtimestamp['time' + indextr] != temp">
                    {{ read[0].jtimestamp["time" + indextr] }}
                  </vs-td>
                  <vs-td v-if="read[0].jtimestamp['time' + indextr] == temp">
                    {{ read[0].jtimestamp["time" + indextr] }}
                  </vs-td>
                </vs-tr>
              </template>
            </template>
          </vs-table>
        </vs-card>
      </vs-col>
    </vs-row>
  </vs-row>
</template>
<script>
export default {
  name: "Control",
  props: ["id", "gid", "nwid", "type", "nwname"],
  data: () => ({
    rediv: 0,
    interval: null,
    windowWidth: window.innerWidth,
    oldread: {},
    read: [],
    // read: {"id":0,"Timestamp":"2020-09-11 09:07:14.08393","serial_id":"000001","control":{"light1":1,"light2":0}},
    dataform: {
      data: "",
      date: 0,
    },
    temp: "",
    popupActivo: false,
    switch1: [true, false],
    switch2: true,
    calldata: [],
    valuename: "",
    valuekey: "",
    edit_name: [],
    name_data: [],
  }),
  methods: {
    editname(editname, item) {
      console.log(item);
      var body = {
        name: editname,
        key: item.key,
      };
      this.$API
        .post("ngk/update/name", body)
        .then((result) => {
          if (result) {
            this.realtime();
            this.$vs.notify({
              title: "Update Status",
              text: "Successful!",
              color: "success",
              position: "top-center",
              icon: "check",
            });
            this.popupActivo = false;
          }
        })
        .catch((err) => {
          if (err) {
            this.realtime();
            this.$vs.notify({
              title: "Update Status was unsuccessful",
              text: "Something wrong.",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
            this.popupActivo = false;
          }
        });
    },
    realtime() {
      this.interval = setTimeout(async () => {
        await this.$API.get("ngk/get/name").then((result) => {
          this.name_data = result.data;
        });
        this.rediv += 1;
        this.realtime()
      }, 10*1000);
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.windowResize();
    },
    windowResize() {
      if (this.windowWidth < 600) {
        // // console.log('small')
      } else {
        // // console.log('big')
      }
    },
    btnChange(item, i) {
      // console.log(this.$session.get('admin'))
      if (this.$session.get("admin") != "poonsak.ngk") {
        this.$vs.notify({
          title: "You don't have permission here",
          text: "This control unit is make for NGK corp.",
          color: "danger",
          position: "top-center",
          icon: "clear",
        });
      } else {
        var control = {};
        var date = Date.now();
        this.temp = date;
        // console.log(item,!this.switch1[i].value)
        this.switch1[i].value = !this.switch1[i].value;
        // console.log(this.switch1)
        this.read[0].jtimestamp["item" + i] = this.$moment(date).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        // // console.log(this.read[0].jtimestamp["item"+i])
        // // console.log(this.read[0].control[item])
        this.switch1.forEach((element, i) => {
          control[Object.keys(this.read[0].control)[i]] = element.value;
        });
        // console.log(control)
        this.$http
          .post(this.$url + "updatecontrol", {
            control: control,
            serial_id: this.id,
            username: this.$session.get("username"),
            rack: item,
            value: !this.switch1[i].value,
            change: this.read[0].control[item],
          })
          .then((result) => {
            if (result) {
              this.$vs.loading();
              this.$vs.notify({
                title: "Update Status",
                text: "Successful!",
                color: "success",
                position: "top-center",
                icon: "check",
              });
              setTimeout(() => {
                // this.$vs.loading.close()
                location.reload();
              }, 5000);
            }
          })
          .catch((err) => {
            if (err) {
              this.$vs.notify({
                title: "Update Status was unsuccessful",
                text: "Something wrong.",
                color: "danger",
                position: "top-center",
                icon: "clear",
              });
            }
          });
      }
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.windowResize();
    var tempswitch = {};
    var conperm = [];
    var check = false;
    this.$API
      .get("sensordatalastcontrol/" + this.id + "/" + this.gid)
      .then((result) => {
        this.$API.get("sensor/serial-id/" + this.id).then((ldata) => {
          this.calldata = result.data;
          conperm = this.$session.get("controlperm");
          // console.log(conperm)
          for (let i = 0; i < this.calldata.length; i++) {
            this.read[i] = this.calldata[i];
          }
          this.read.forEach((element, i) => {
            Object.keys(element.jtimestamp).forEach((el) => {
              this.read[i].jtimestamp[el] = this.$moment(
                this.$moment(this.read[i].jtimestamp[el]).subtract(7, "hours")
              ).format("YYYY-MM-DD HH:mm:ss");
            });
          });
          this.oldread = this.read[0].control;
          Object.keys(this.read[0].control).forEach((e, i) => {
            this.read[0].control[e] = {
              value: this.read[0].control[e],
              visible: true,
            };
            this.switch1[i] = result.data[0].control[e];
          });
          this.read[0].control = JSON.parse(ldata.data[0].lastdata[0]);
          Object.keys(this.read[0].control).forEach((e, i) => {
            if (conperm != null) {
              conperm.forEach((con) => {
                if (con == e) {
                  check = true;
                }
              });
            } else {
              this.read[0].control[e] = {
                value: this.read[0].control[e],
                visible: true,
              };
            }
            if (check) {
              this.read[0].control[e] = {
                value: this.read[0].control[e],
                visible: true,
              };
              check = false;
            } else if (conperm) {
              this.read[0].control[e] = {
                value: this.read[0].control[e],
                visible: false,
              };
              check = false;
            }
            // this.switch1[i] = this.read[0].control[e]['value']
            // this.switch1[i] = result.data[0].control[e]
          });
          // console.log(this.read[0].control,this.switch1)
          // Object.keys(this.read.control).forEach((item) => {
          //   // eslint-disable-next-line no-console
          //   // console.log(this.read.control[item])
          // })
        });
      });
    this.$API.get("ngk/get/name").then((result) => {
      this.name_data = result.data;
    });
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>
<style scoped>
.cardborder {
  border-radius: 20px;
}
.cardborderdanger {
  border-radius: 20px;
  background: #fe844b;
}
.colorgray {
  color: rgba(0, 0, 0, 0.4);
}
.edit_hover_class a {
  display: none;
}
.edit_hover_class:hover a {
  display: block;
}
.iconcursoredit {
  cursor: pointer;
}
.widthbtn {
  width: 80px;
  border-radius: 20px;
}
</style>
